import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'
import { useShowDoorSelector } from '@/features/integrationDoor'

export function useTypeToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [GraphQL.GoodieType.Default]: t`Offer`,
      [GraphQL.GoodieType.Event]: t`Event`,
      [GraphQL.GoodieType.Message]: t({
        id: 'goodie.type.message',
        message: `Message`
      })
    }
  }, [t])
}

export function useGoodieTypeOptions() {
  const typeToLabel = useTypeToLabel()

  return useMemo(() => {
    return [
      {
        label: typeToLabel[GraphQL.GoodieType.Default],
        value: GraphQL.GoodieType.Default
      },
      {
        label: typeToLabel[GraphQL.GoodieType.Event],
        value: GraphQL.GoodieType.Event
      },
      {
        label: typeToLabel[GraphQL.GoodieType.Message],
        value: GraphQL.GoodieType.Message
      }
    ]
  }, [typeToLabel])
}

export function useDefaultButtonTypeOptions() {
  const { t } = useLingui()
  const showDoorSelector = useShowDoorSelector()

  const options = [
    {
      value: GraphQL.DefaultButtonType.Hide,
      label: t`Hide`
    },
    {
      value: GraphQL.DefaultButtonType.Bookable,
      label: t`Book Dialog`
    },
    {
      value: GraphQL.DefaultButtonType.File,
      label: t`File`
    },
    {
      value: GraphQL.DefaultButtonType.Link,
      label: t`Link`
    }
  ]

  if (showDoorSelector) {
    options.push({
      value: GraphQL.DefaultButtonType.OpenDoor,
      label: t`Open Door`
    })
  }

  return options
}

export function useEventButtonTypeOptions() {
  const { t } = useLingui()
  const showDoorSelector = useShowDoorSelector()

  const options = [
    {
      value: GraphQL.EventButtonType.Hide,
      label: t`Hide`
    },
    {
      value: GraphQL.EventButtonType.Bookable,
      label: t`Book Dialog`
    }
  ]

  if (showDoorSelector) {
    options.push({
      value: GraphQL.EventButtonType.OpenDoor,
      label: t`Open Door`
    })
  }

  return options
}
